"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var createFeature_1 = require("../createFeature");
exports.setReadonlyAction = (_a = createFeature_1.createInputFeature('readonly'), _a.actionCreator), exports.readonlySelector = _a.selectorCreator, exports.ReadonlyFeature = _a.featureReducer;
//# sourceMappingURL=readonly.js.map